import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Observation.css";
import { AiFillHome } from "react-icons/ai";
import { db } from "../../firebase";
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import imageCompression from "browser-image-compression";
import axios from "axios";

function Aobs() {
  const navigate = useNavigate();
  const [comment, setComment] = useState("");
  const [hotel, setHotel] = useState("Centauria Lake Resort"); // 🔹 hotel state
  const [comments, setComments] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");
  const [popupImage, setPopupImage] = useState(null);
  const auth = getAuth();
  const userEmail = auth.currentUser?.email || null;
  const [imagePreviews, setImagePreviews] = useState([]); // preview URLs
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);

  
  // 🔹 Real-time comments (only Centauria Lake Resort)
    useEffect(() => {
      const q = query(
        collection(db, "observations"),
        where("hotelName", "==", "Centauria Lake Resort"),
        orderBy("createdAt", "desc")
      );

      const unsubscribe = onSnapshot(q, (snapshot) => {
        const commentList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setComments(commentList);
      });

      return () => unsubscribe();
    }, []);
    ;

  const handleImageChange = (e) => {
  const files = Array.from(e.target.files);

  // Append new files to existing ones
  setImages((prevImages) => [...prevImages, ...files]);

  // Append new previews to existing ones
  const newPreviews = files.map((file) => URL.createObjectURL(file));
  setImagePreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
};

const removeImage = (index) => {
  setImages((prev) => prev.filter((_, i) => i !== index));
  setImagePreviews((prev) => prev.filter((_, i) => i !== index));
};

// 🔹 Upload images to Cloudinary and get URLs
  const uploadImages = async () => {
    const urls = [];

    for (const image of images) {
      try {
        // Compress the image
        const compressedFile = await imageCompression(image, {
          maxSizeMB: 0.2, // reduce size
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        });

        const formData = new FormData();
        formData.append("file", compressedFile);
        formData.append("upload_preset", "observation"); // create in Cloudinary

        const res = await axios.post(
          "https://api.cloudinary.com/v1_1/dmrobupcg/image/upload",
          formData
        );

        urls.push(res.data.secure_url);
      } catch (err) {
        console.error("Image upload error:", err);
      }
    }

    return urls;
  };


  // 🔹 Submit new comment
  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!hotel) {
      setError("Please select a hotel.");
      return;
    }
    if (!comment.trim()) {
      setError("Comment cannot be empty.");
      return;
    }
    if (!userEmail) {
      setError("No logged-in user found. Please sign in first.");
      return;
    }

    
    setSubmitting(true);
        try {
          setUploading(true);
          const imageUrls = images.length > 0 ? await uploadImages() : [];
    
          await addDoc(collection(db, "observations"), {
            text: comment,
            hotelName: hotel,
            status: "Incomplete",
            userEmail,
            createdAt: serverTimestamp(),
            images: imageUrls, // save image links in Firestore
          });
    
          setComment("");
          setHotel("");
          setImages([]);
          setImagePreviews([]);
        } catch (err) {
          console.error(err);
          setError("Failed to submit. Try again.");
        } finally {
          setSubmitting(false);
          setUploading(false);
        }
      };

  // 🔹 Start editing a comment
  function handleEditStart(c) {
    setEditingId(c.id);
    setEditText(c.text);
  }

  // 🔹 Save edited comment
  async function handleEditSave(id) {
    try {
      const docRef = doc(db, "observations", id);
      await updateDoc(docRef, {
        text: editText,
        updatedAt: serverTimestamp(),
      });
      setEditingId(null);
      setEditText("");
    } catch (err) {
      console.error("Edit failed:", err);
    }
  }

  // 🔹 Delete comment with confirmation
  async function handleDelete(id) {
    const confirmDelete = window.confirm("Are you sure you want to delete this comment?");
    if (!confirmDelete) return;

    try {
      const docRef = doc(db, "observations", id);
      await deleteDoc(docRef);
    } catch (err) {
      console.error("Delete failed:", err);
    }
  }

  // 🔹 Format "time ago"
  function timeAgo(date) {
    if (!date) return "Just now";

    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days}d`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months}mo`;
    const years = Math.floor(months / 12);
    return `${years}y`;
  }

  // 🔹 Mark observation as completed
async function handleDone(id) {
  try {
    // Optimistically update local state
    setComments((prev) =>
      prev.map((c) =>
        c.id === id ? { ...c, status: "Completed" } : c
      )
    );

    const docRef = doc(db, "observations", id);
    await updateDoc(docRef, {
      status: "Completed",
      updatedAt: serverTimestamp(),
    });
  } catch (err) {
    console.error("Failed to mark as done:", err);
  }
}

  return (
    <div className="observation-root">
      <div className="observation-container">
        <h2>Observations 📝</h2>
        <form className="observation-form" onSubmit={handleSubmit}>
          {/* 🔹 Hotel Dropdown */}
          <select
            value={hotel}
            onChange={(e) => setHotel(e.target.value)}
            required
          >
            {/* <option value="">-- Select Hotel --</option> */}
            <option value="Centauria Lake Resort">Centauria Lake Resort</option>
            {/* <option value="Centauria Hill Resort">Centauria Hill Resort</option>
            <option value="Centauria Wild Resort">Centauria Wild Resort</option>
            <option value="Centauria Beach Resort">Centauria City Resort</option> */}
          </select>

          <br></br> <br></br>

          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Write your observation..."
            rows={3}
          />

           {/* 🔹 Image upload */}
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageChange}
          />

          {error && <div className="form-error">{error}</div>}

           {/* Image previews */}
            {imagePreviews.length > 0 && (
              <div className="image-preview-container">
                {imagePreviews.map((previewSrc, idx) => (
                  <div key={idx} className="image-preview">
                    <img src={previewSrc} alt={`preview-${idx}`} />
                    <button
                      type="button"
                      onClick={() => removeImage(idx)}
                      className="remove-image-btn"
                    >
                      ❌
                    </button>
                  </div>
                ))}
              </div>
            )}

          <div className="button-row">
            <button type="submit" className="btn-primary" disabled={submitting || uploading}>
              {submitting || uploading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>

        <div className="comment-section">
          <h3>Previous Observations</h3>
          {comments.length > 0 ? (
            <ul className="comment-list">
              {comments.map((c) => {
                const date = c.updatedAt?.toDate
                  ? timeAgo(c.updatedAt.toDate())
                  : c.createdAt?.toDate
                  ? timeAgo(c.createdAt.toDate())
                  : "Just now";

                return (
                  <li key={c.id} className="comment-item">
                    {editingId === c.id ? (
                      <>
                        <textarea
                          value={editText}
                          onChange={(e) => setEditText(e.target.value)}
                          rows={2}
                        />
                        {/* <div className="edit-actions">
                          <button
                            className="btn-primary small"
                            onClick={() => handleEditSave(c.id)}
                          >
                            Save
                          </button>
                          <button
                            className="btn-secondary small"
                            onClick={() => setEditingId(null)}
                          >
                            Cancel
                          </button>
                        </div> */}
                      </>
                    ) : (
                      <>
                        <p className="comment-text">{c.text}</p>
                        {/* <span className="comment-hotel">🏨 {c.hotelName || "Unknown Hotel"}</span> */}
                        <span className="comment-email">
                          {c.userEmail?.split("@")[0]}
                        </span>
                        <span className="comment-date">{date}</span>

                        {c.images && c.images.length > 0 && (
                          <div className="comment-images">
                            {c.images.map((url, i) => (
                              <img
                                key={i}
                                src={url}
                                alt={`comment-${i}`}
                                className="comment-img"
                                onClick={() => setPopupImage(url)} // open popup
                                style={{ cursor: "pointer" }}
                              />
                            ))}
                          </div>
                        )}

                        {/* {c.userEmail === userEmail && ( */}
                          <div className="comment-actions">
                            {c.status !== "Completed" ? (
                              <button
                                className="btn-primary small"
                                onClick={() => handleDone(c.id)}
                              >
                                Done
                              </button>
                            ) : (
                              <span className="completed-label">✅ Completed</span>
                            )}
                          </div>
                        
                      </>
                    )}
                  </li>
                );
              })}
            </ul>
          ) : (
            <p>No comments yet.</p>
          )}
        </div>
         {/* 🔹 IMAGE POPUP */}
      {popupImage && (
        <div
          className="image-popup"
          onClick={() => setPopupImage(null)} // close on click
        >
          <img src={popupImage} alt="popup" className="popup-img"/>
        </div>
      )}
      </div>
    </div>
  );
}

export default Aobs;
